import { render } from "./rewardsBanner.vue?vue&type=template&id=37e33b22&scoped=true&ts=true"
import script from "./rewardsBanner.vue?vue&type=script&lang=ts"
export * from "./rewardsBanner.vue?vue&type=script&lang=ts"

import "./rewardsBanner.vue?vue&type=style&index=0&id=37e33b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e33b22"]])

export default __exports__